/** Analytics en login-teller na een geslaagde Firebase-authenticatie. */
import { initAnalytics, logSignup, logLogin } from '@/services/analyticsService';
import { incrementLoginCount } from '@/services/userService';

/**
 * Bepaalt of dit een nieuwe registratie is op basis van user metadata.
 * @param {import('firebase/auth').User} user
 * @returns {boolean}
 */
const isNewUser = (user) => {
  try {
    return user.metadata.creationTime === user.metadata.lastSignInTime;
  } catch {
    return false;
  }
};

/**
 * Firet analytics events en update login count na inloggen.
 * @param {import('firebase/auth').User} user
 * @param {string} method - 'google' | 'anonymous' | 'password'
 */
export const handlePostLogin = async (user, method) => {
  try {
    await initAnalytics();

    if (isNewUser(user)) {
      logSignup({ method, userId: user.uid });
    }
    logLogin({ method, userId: user.uid });

    await incrementLoginCount(user.uid).catch((err) => {
      console.error('Failed to increment login count:', err);
    });
  } catch (err) {
    console.error('Analytics post-login error:', err);
  }
};
